import { cn } from '@form-factory/chatbot-ui';
import { cva, type VariantProps } from 'class-variance-authority';
import { memo, type ButtonHTMLAttributes } from 'react';

const accentButtonStyles = cva(
  'flex shrink-0 items-center gap-1 rounded-md px-1.5 py-1 transition-all enabled:hover:scale-105 enabled:hover:opacity-70 enabled:active:scale-100 disabled:cursor-not-allowed disabled:opacity-75 [&>svg]:size-4',
  {
    variants: {
      variant: {
        primary: 'border-green-500 bg-green-500/25 text-green-500',
        secondary: 'border-amber-500 bg-amber-500/25 text-amber-500',
        default: 'bg-chat-background-secondary text-chat-foreground',
      },
      size: {
        xs: 'text-xs',
        sm: 'text-sm',
      },
    },
    defaultVariants: {
      variant: 'primary',
      size: 'xs',
    },
  },
);

export interface AccentButtonProps
  extends ButtonHTMLAttributes<HTMLButtonElement>,
    VariantProps<typeof accentButtonStyles> {}

export const AccentButton = memo(
  ({ className, variant, size, ...props }: AccentButtonProps) => (
    <button
      type='button'
      className={cn(accentButtonStyles({ variant, size }), className)}
      {...props}
    />
  ),
);
